import { render, staticRenderFns } from "./Forecast.vue?vue&type=template&id=52f97239&scoped=true"
import script from "./Forecast.vue?vue&type=script&lang=js"
export * from "./Forecast.vue?vue&type=script&lang=js"
import style0 from "./Forecast.vue?vue&type=style&index=0&id=52f97239&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f97239",
  null
  
)

export default component.exports